import { render, staticRenderFns } from "./newsletter-subscription-v2.vue?vue&type=template&id=2af6dc4e"
import script from "./newsletter-subscription-v2.vue?vue&type=script&lang=js"
export * from "./newsletter-subscription-v2.vue?vue&type=script&lang=js"
import style0 from "./newsletter-subscription-v2.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports